import {GlobalizationConfig} from 'src/app/shared/interfaces/globalization-config.interface';
import {AttributeType} from 'src/app/shared/modals/filters/models/filter-models';

export interface AreaConfig {
    areaId: number;
    attributeType?: AttributeType;
    attributeAction?: AreaConfigAttributeAction;
    globalizationConfig: GlobalizationConfig;
    minEvaluators: number;
    maxEvaluators: number;
    requiresEvaluatorsValidation: boolean;
    hideColumnsOnTable?: boolean;
    showUsersFromAttributesType?: boolean;
    userAttributesType?: Array<number>;
    id: number;
}

export interface AggregatedAreaConfig {
    id: number;
    globalizationConfig: GlobalizationConfig;
}

export enum AreaConfigAttributeAction {
    Exclude,
    Include
}

export interface AreaSelectionError {
    error: AreaSelectionErrorEnum;
    areaId: number;
}

export enum AreaSelectionErrorEnum {
    NoErrors,
    ZeroEvaluators,
    DifferentEvaluators,
}